export const FAQ_AUDIENCE_OPTIONS = [
  {
    slug: 'general',
    label: 'General',
    subtitle: 'Login, accounts, and common questions',
    icon: 'ℹ️',
  },
  {
    slug: 'admin',
    label: 'School Administrator',
    subtitle: 'Headmaster / Admin — full school management',
    icon: '🏫',
  },
  {
    slug: 'teacher',
    label: 'Teacher',
    subtitle: 'Class teacher — attendance, routine, students',
    icon: '👩‍🏫',
  },
  {
    slug: 'parent',
    label: 'Parent',
    subtitle: 'Parent / guardian — child progress & notices',
    icon: '👨‍👩‍👧',
  },
  {
    slug: 'student',
    label: 'Student',
    subtitle: 'Student portal — timetable, notices, profile',
    icon: '🎓',
  },
];

export const FAQ_AUDIENCE_GENERAL = 'general';

export function getFaqAudienceLabel(slug) {
  const match = FAQ_AUDIENCE_OPTIONS.find((item) => item.slug === slug);
  return match?.label || 'General';
}

export function faqMatchesAudience(faq, activeAudience) {
  const slug = String(faq.audience || faq.category_slug || '').trim().toLowerCase() || FAQ_AUDIENCE_GENERAL;
  if (activeAudience === FAQ_AUDIENCE_GENERAL) {
    return slug === FAQ_AUDIENCE_GENERAL;
  }
  return slug === activeAudience || slug === FAQ_AUDIENCE_GENERAL;
}
